"use client";

import { Footer } from "~/app/_components/Footer";
import { Header } from "~/app/_components/Header";
import { MobileNavProvider } from "~/app/_components/MobileNavContext";
import { Sidebar } from "~/app/_components/Sidebar";

export function StoreLayout({ children }: { children: React.ReactNode }) {
  return (
    <MobileNavProvider>
      <div className="flex min-h-screen flex-col bg-stone-50">
        <Header />
        <div className="flex flex-1">
          <Sidebar />
          <main
            id="main-content"
            className="min-w-0 flex-1 p-4 sm:p-6"
          >
            {children}
          </main>
        </div>
        <Footer />
      </div>
    </MobileNavProvider>
  );
}
